/**
 * firebase.js → Workers Auth 호환 래퍼
 * Firebase SDK를 제거하고 Cloudflare Workers JWT 기반으로 교체
 * 기존 코드의 import 경로를 유지하면서 API만 교체
 */

const API_BASE = process.env.REACT_APP_API_URL || 'https://epix-card-worker.rkvrh00.workers.dev';

// ─── 토큰 저장소 ─────────────────────────────────────────────────
export function getStoredToken() {
  return localStorage.getItem('epix_jwt');
}
export function setStoredToken(token) {
  localStorage.setItem('epix_jwt', token);
}
export function clearStoredToken() {
  localStorage.removeItem('epix_jwt');
}

// ─── Web Push VAPID 공개키 ────────────────────────────────────────
export const VAPID_KEY = process.env.REACT_APP_VAPID_KEY || '';

/**
 * Web Push 구독 요청 (FCM 대체)
 * @returns {Promise<PushSubscription|null>}
 */
export async function requestFCMToken() {
  try {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return null;

    // VAPID 공개키 서버에서 가져오기
    let vapidKey = VAPID_KEY;
    if (!vapidKey) {
      const res = await fetch(`${API_BASE}/api/push/vapid-public-key`);
      if (res.ok) {
        const data = await res.json();
        vapidKey = data.vapidPublicKey;
      }
    }
    if (!vapidKey) return null;

    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(vapidKey),
    });
    return sub;
  } catch {
    return null;
  }
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map(c => c.charCodeAt(0)));
}

// ─── 더미 onMessage (Firebase 호환용, Web Push는 SW에서 처리) ────
export function onMessage(_messaging, _callback) {
  // Web Push 포그라운드 메시지는 서비스워커에서 처리
  // 빈 unsubscribe 함수 반환
  return () => {};
}

// ─── firebase.js 에서 export 하던 것들 호환용 ────────────────────
export const auth = null;       // Workers JWT로 대체됨
export const db = null;         // D1으로 대체됨
export const messaging = null;  // Web Push로 대체됨
export const googleProvider = null;
